<template>
	<div v-if="parent_data" class="el-mean-slider" :class="{ 'can-change': is_editable }">
		<div class="slider-bg" ref="slider_bg">
			<div class="thumb" :style="{ left: value_percent + '%' }"><div class="tooltip">{{ tooltip }}</div></div>
		</div>
		<div v-if="values.length" class="slider-data">
			<span v-for="v in values" :key="v">{{ v }}</span>
		</div>
		<div v-if="labels.length" class="slider-legends">
			<span v-for="label in labels" :key="label">{{ label }}</span>
		</div>
		<div class="slider-action" @click="change_value($event)" ref="slider_action"></div>

		<!-- Display error div -->
		<div v-if="is_edit_mode && rootComponent && rootComponent.error" class="error-container  edit-error">
			<div class='content-error'>{{rootComponent.error_message}}</div>
		</div>
		<div v-if="!is_edit_mode && rootComponent && rootComponent.error" class="error-container  read-error">
			<div class='content-error'>{{rootComponent.error_message}}</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";

export default {
	name: "el-mean-slider",
	mixins: [ ElementMixin ],
	data: function () {
		return {
			percent: 0
		};
	},
	props: {
		values: { default: function () { return []; } },
		labels: { default: function () { return []; } },
		show_max: { default: true },
		max: { default: 100 },
		editable: { default: false },
		rootComponent: {default: {}}
	},
	computed: {
		...mapGetters(["editor"]),
		is_edit_mode: function (){
			const result = this.editor.mode == "editing";
			return result;
		},
		tooltip () {
			if (this.show_max) {
				return this.value_text + "/" + this.max;
			}
			return this.value_text;
		},
		value_float () {
			const value = this.value ? this.value : 0;
			if (typeof (value) == "number") {
				return Math.min(value, this.max);
			}
			const v = value.replace(",", ".");
			return Math.min(parseFloat(v), this.max);
		},
		value_text () {
			return this.value_float.toFixed(2);
		},
		value_percent: function () {
			return this.value_float * 100 / this.max;
		}
	},
	// watch: {
	// 	value: function() {
	// 		this.percent = this.value
	// 	}
	// },
	methods: {
		change_value: function ($event) {
			if (this.is_editable) {
				const x = $event.layerX;
				const percent = x * 100 / this.$refs.slider_bg.offsetWidth;
				const new_value = Number(Math.round((percent * this.max / 100)*2)/2);
				this.edit_study(new_value);
			}
		}
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.error-container
	z-index: 20000
	position absolute
	top -24px
	left 0
	width 101% !important
	height 200% !important
	text-align center
	border-style solid
	border-width 2px
	overflow-y hidden
	margin-left -2px
	margin-top 16px
	.content-error
		position relative
		top 50%
		transform translateY(-50%)


.edit-error
	opacity 0.8
	background-color black
	color red
	border-color red

.read-error
	opacity 1
	background-color white
	color #3e5d58
	border-color #3e5d58


.el-mean-slider
	height 16px
	margin 4px 0 8px 0
	line-height @height
	cursor default
	&:hover
		.slider-bg .thumb .tooltip
			display block
	&.can-change
		&:before
			content ''
			position absolute
			left -7px
			top -7px
			right -7px
			bottom -7px
			box-shadow 0 0 0 1px purple
			background-color lighten(purple, 85%)
			border-radius 50px
		.slider-action
			display block
	.slider-data, .slider-legends
		position absolute
		width 100%
		height 16px
		bottom -@height
		display flex
		align-items center
		justify-content space-between
		font-size 8px
		color alpha(main_color, 75%)
		line-height @height
		font-weight 500
		span
			display inline-block
	.slider-data
		bottom auto
		top 0
		height 16px
		line-height @height
		padding 0 8px
		color dark
		cursor default
	.slider-bg
		height 100%
		width 100%
		background-color #eee
		background linear-gradient(to right, #DADC50, #61B576)
		border-radius 24px
		.thumb
			position absolute
			left 0
			top -4px
			bottom -4px
			width 4px
			margin-left -2px
			background-color main_color
			border-radius 2px
			box-shadow 0 0 0 2px #fff
			z-index 2
			transition 0.2s easeOutQuart
			.tooltip
				display none
				position absolute
				right 2px
				top -32px
				height 24px
				padding 0 8px
				transform translateX(50%)
				background-color dark
				color #fff
				line-height 24px
				user-select none
				&:before
					content ''
					position absolute
					left calc(50% - 4px)
					bottom -4px
					width 0
					height 0
					border-style solid
					border-width 4px 4px 0 4px
					border-color dark transparent transparent transparent
	.slider-action
		display none
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		cursor pointer
</style>
